import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import GeneratedNotesPage from "./Pages/GenerateNotes";

const Home = () => <h2>Welcome to the Home Page</h2>;

const App = () => {
  return (
    <Router>
      <div>
        <main>
          <Routes>
            <Route path="/" element={<GeneratedNotesPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
};

export default App;
